module.exports = __webpack_public_path__ + "img/small-12.675f685d.webp";